import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-500 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}